import React from 'react';
import styled from 'styled-components';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  AreaChart,
} from 'recharts';

import { Card } from 'Components/ui';

const Subtitle = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: var(--vo-ink);
  margin-bottom: 16px;
  display: block;
`;

const CardSubtitle = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-slate);
  margin: -10px 0 12px;
  display: block;
  line-height: 1.5;
`;

const ChartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChartLine = ({ title, data, tooltipLabel, color = 'var(--vo-purple)', height = 210, cardSubtitle }) => {
  const gradientId = 'gradientFill';

  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString('pt-BR', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Card>
      <Subtitle>{title}</Subtitle>
      {cardSubtitle && <CardSubtitle>{cardSubtitle}</CardSubtitle>}

      <ChartWrapper>
        <ResponsiveContainer width="100%" height={height}>
          <AreaChart  data={data}>
            <defs>
              <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.4} />
                <stop offset="95%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid strokeDasharray="3 3" vertical={false} />

            <XAxis
              dataKey="date"
              tickFormatter={formatDate}
              tick={{ fontSize: 12 }}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              domain={[0, 100]}
              tickFormatter={(v) => `${v}%`}
              tick={{ fontSize: 12 }}
              tickLine={false}
              axisLine={false}
            />

            <Tooltip
              formatter={(value) => [`${value.toFixed(2)}%`, tooltipLabel]}
              labelFormatter={formatDate}
            />

            <Area
              type="monotone"
              dataKey="value"
              stroke={color}
              fill={`url(#${gradientId})`}
              strokeWidth={2}
              dot={false}
            />
          </AreaChart >
        </ResponsiveContainer>
      </ChartWrapper>
    </Card>
  );
};

export default ChartLine;
